// Global axios safety net.
//
// Goal: GUARANTEE that no request from the production frontend ever leaks to
// the preview backend, regardless of what was baked into the bundle at build
// time. We install a single request interceptor that:
//   1. Detects when the app is being served from a production custom domain
//      (NOT *.preview.emergentagent.com and NOT localhost).
//   2. Rewrites any absolute URL pointing at *.preview.emergentagent.com into
//      a relative path — so the request stays SAME-ORIGIN and Emergent's
//      reverse proxy routes /api/* to the backend on the same domain.
//
// This is intentionally defensive: even if a contributor hardcodes a URL or
// forgets to use the API_BASE helper, this interceptor catches it.
import axios from "axios";

const PREVIEW_HOST_REGEX = /\.preview\.emergentagent\.com$/i;
const PREVIEW_URL_REGEX = /^https?:\/\/[^/]*\.preview\.emergentagent\.com/i;

function isProductionOrigin() {
  if (typeof window === "undefined" || !window.location) return false;
  const host = window.location.hostname || "";
  if (!host) return false;
  if (host === "localhost" || host === "127.0.0.1") return false;
  if (PREVIEW_HOST_REGEX.test(host)) return false;
  return true;
}

axios.interceptors.request.use((config) => {
  try {
    if (isProductionOrigin() && config && typeof config.url === "string") {
      // Strip any absolute preview origin so the URL becomes relative
      // (same-origin) on the production domain.
      if (PREVIEW_URL_REGEX.test(config.url)) {
        config.url = config.url.replace(PREVIEW_URL_REGEX, "");
      }
      // Also clear any baseURL pointing at preview.
      if (typeof config.baseURL === "string" && PREVIEW_URL_REGEX.test(config.baseURL)) {
        config.baseURL = config.baseURL.replace(PREVIEW_URL_REGEX, "");
      }
    }
  } catch {
    // Never let the interceptor itself break the request.
  }
  return config;
});
